import Flex from 'UIKit/Box/Flex'
import Grid from 'UIKit/Box/Grid'
import Text from 'UIKit/Text'
import { GamePlayAction } from 'config/types/game'
import useModal from 'hooks/useModal'
import { RowBetween, RowMiddle } from 'layout/Components/Row'
import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import GameService from 'services/GameService'
import { useTournamentDetails } from 'state/tournament/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import GameItem from 'views/Games/components/GameItem'
import { CardSection, CardTitle } from 'views/Tournament'
import EligibleGamesModal from './EligibleGamesModal'
import GameItemActions from './GameItemAction'

const EligibleGames: React.FC<{ gameCollectionId: number; onGameSelected: () => void }> = ({
  gameCollectionId,
  onGameSelected,
}) => {
  const [presentModalChooseGame] = useModal(EligibleGamesModal)
  const { tournamentDetails } = useTournamentDetails()

  const request = useCallback(
    (offset: number, limit: number) => {
      return GameService.getGames({ gameCollectionId }, offset, limit, true, true)
    },
    [gameCollectionId],
  )

  return (
    <CardSection>
      <RowBetween>
        <RowMiddle>
          <CardTitle>Eligible Games</CardTitle>
          <Text
            color="textTertiary"
            fontSize="14px"
            fontWeight={700}
            lineHeight="22px"
            letterSpacing="-0.28px"
            ml="4px"
          >
            ({tournamentDetails.totalGames})
          </Text>
        </RowMiddle>
        {tournamentDetails.totalGames > 6 && (
          <StyledTextButton
            alignItems="center"
            onClick={() =>
              presentModalChooseGame({
                request,
                titleHeader: 'Eligible Games',
                contentDescription: '',
                playAction: GamePlayAction.Play,
                onGameSelected,
                gameCollectionId,
                totalGames: tournamentDetails.totalGames,
              })
            }
          >
            <Text mr="5px" fontSize="12px" color="textSubtle">
              <Trans>View All</Trans>
            </Text>
            <Icons.ChevronRightIcon width="4.5px" fill={colors.textDisable} />
          </StyledTextButton>
        )}
      </RowBetween>

      <Text
        color="textAlt1"
        fontSize="12px"
        fontWeight={500}
        letterSpacing={-0.24}
        my="8px"
        style={{ wordBreak: 'break-word' }}
      >
        <Trans>Please choose a desirable game to join Tourament.</Trans>
      </Text>

      <Grid
        position="relative"
        gridGap={['12px', '', '16px']}
        gridTemplateColumns={['1fr 1fr', '1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr']}
      >
        {tournamentDetails.defaultGames?.map((game) => (
          <GameItem
            game={game}
            p="0px !important"
            gamePlayAction={GamePlayAction.Play}
            handlePlayFn={onGameSelected}
            ActionComponent={GameItemActions}
          />
        ))}
      </Grid>
    </CardSection>
  )
}

const StyledTextButton = styled(Flex)`
  cursor: pointer;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.colors.textAlt1};
  }

  &:hover {
    ${Text} {
      color: ${({ theme }) => theme.colors.text} !important;
    }

    svg {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`

export default React.memo(EligibleGames)
